module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu"
  }, [_vm._l((_vm.routes), function(item) {
    return [(!item.hidden && item.children) ? _c('el-submenu', {
      key: item.name,
      attrs: {
        "index": item.name
      }
    }, [_c('template', {
      slot: "title"
    }, [(item.meta && item.meta.icon) ? _c('i', {
      class: item.meta.icon
    }) : _vm._e(), _vm._v(" "), (item.meta && item.meta.title) ? _c('span', [_vm._v(_vm._s(item.meta.title))]) : _vm._e()]), _vm._v(" "), _vm._l((item.children), function(child) {
      return [(!child.hidden && child.children && child.children.length) ? _c('menu-list', {
        key: child.name,
        attrs: {
          "routes": [child]
        }
      }) : (!child.hidden) ? _c('router-link', {
        key: child.name,
        attrs: {
          "to": child.path
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": child.path
        }
      }, [(child.meta && child.meta.icon) ? _c('i', {
        class: child.meta.icon
      }) : _vm._e(), _vm._v(" "), (child.meta && child.meta.title) ? _c('span', [_vm._v(_vm._s(child.meta.title))]) : _vm._e()])], 1) : _vm._e()]
    })], 2) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-cae95292"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/menuList.vue
// module id = 628
// module chunks = 70